import Button from "component/ui/Button";
import React, { useEffect, useState } from "react";
import "react-accessible-accordion/dist/fancy-example.css";
// import DateSelect from "./dateSelect";
import RadioButton from "component/ui/RadioButton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getCurrentCountryName } from "helper/appConstant";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  blockBookingSlots,
  getListOfVenueSlots,
  getVenueBookedSlotListing,
  unblockBookingSlots,
} from "store/slice/profile";
import { FaCircle, FaRegCircle } from "react-icons/fa";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import ConfirmationDialog from "component/dialogs/ConfirmationDialog";
import DateSelect from "./dateSelect";
import BackButton from "component/ui/BackButton";
import PagHeading from "component/ui/PageHeading";
const ArenaDetails = () => {
  const { venueId, id } = useParams();
  const location = useLocation();
  const today = new Date();
  const { venueBookingSlotsList, venueBookedSlots } = useSelector(
    (state) => state.profile
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [slotsData, setSlotsData] = useState(null);
  const [venueBookedSlotsData, setVenueBookedSlotsData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showDeleteArenaDialog, setShowDeleteArenaDialog] = useState(false);
  const [isBlock, setIsBlock] = useState(false);
  // fetch todays venus slots list
  useEffect(() => {
    fetchVenueSlotsList(today);
  }, []);

  // fetch venue slots list
  const fetchVenueSlotsList = (date) => {
    const request = {
      language: "en",
      sportsName: location?.state?.arena?.sportsName,
      venueId: venueId,
      country: getCurrentCountryName(),
      courtDetailId: id,
      slotStartTime: null,
      slotDate: moment(date)?.format("YYYY-MM-DD"),
    };
    dispatch(getListOfVenueSlots(request));
    // fetch blocked slots listing

    const getBlockedRequest = {
      language: "en",
      page: 1,
      perPage: 100,
      sportId: location?.state?.arena?._id ?? "",
      bookingDate: moment(date)?.format("YYYY-MM-DD"),
    };

    dispatch(getVenueBookedSlotListing(getBlockedRequest));
  };
  // set slots data
  useEffect(() => {
    if (venueBookingSlotsList) {
      setSlotsData(venueBookingSlotsList?.data);
    }
  }, [venueBookingSlotsList]);
  // set booked slot data
  useEffect(() => {
    if (venueBookedSlots) {
      setVenueBookedSlotsData(
        venueBookedSlots?.filter(
          (item) => item?.courtDetailId == location?.state?.court?._id
        )
      );
    }
  }, [venueBookingSlotsList]);
  //  Toggle slot PER ARENA
  const toggleSlot = (slotId, sportId) => {
    setSlotsData((prev) =>
      prev.map((court) => ({
        ...court,
        sportsId: sportId,
        slots: court.slots.map((slot) =>
          slot.slotId === slotId
            ? { ...slot, isSelected: !slot.isSelected }
            : slot
        ),
      }))
    );
  };
  // handle success of blocked slots
  const handleBlockedSuccess = () => {
    fetchVenueSlotsList(selectedDate);
  };
  // Block selected slots PER ARENA
  const handleMarkAsBlocked = (isAllBlock) => {
    const request = {
      language: "en",
      sportsId: location?.state?.arena?._id,
      slotId: isAllBlock
        ? []
        : slotsData
            ?.flatMap((item) => item?.slots || [])
            .filter((slot) => slot?.isSelected)
            .map((slot) => slot.slotId),
      courtId: location?.state?.court?._id,
      bookingDate: moment(selectedDate)?.format("YYYY-MM-DD"),
      slotBlockType: isAllBlock ? 2 : 1,
    };
    dispatch(blockBookingSlots(request, handleBlockedSuccess));
  };
  //  Toggle slot for unblock slot
  const toggleUnblockSlot = (bookingId) => {
    setVenueBookedSlotsData((prev) =>
      prev.map((court) => ({
        ...court,
        slots: court.slots.map((slotGroup) => ({
          ...slotGroup,
          slots: slotGroup.slots.map((slot) =>
            slot.bookingId === bookingId
              ? {
                  ...slot,
                  isUnblockSelected: !slot.isUnblockSelected,
                }
              : slot
          ),
        })),
      }))
    );
  };

  // unblock selected slots
  const handleMarkAsUnBlocked = () => {
    const request = {
      language: "en",
      bookingId:
        venueBookedSlotsData?.flatMap(
          (court) =>
            court?.slots?.flatMap(
              (slotGroup) =>
                slotGroup?.slots
                  ?.filter((slot) => slot?.isUnblockSelected)
                  .map((slot) => slot.bookingId) || []
            ) || []
        ) || [],
      courtId: null,
      bookingDate: moment(selectedDate)?.format("DD-MM-YYYY"),
      slotBlockType: 1,
    };
    dispatch(unblockBookingSlots(request, handleBlockedSuccess));
  };

  console.log("venueBookedSlots", venueBookedSlotsData);
  return (
    <div className="min-h-screen bg-gray-100 md:p-5 p-3">
      <div className="container mx-auto">
        <BackButton
          onClick={() => {
            navigate("/venue-operations?type=3");
          }}
        />
      </div>
      <div className="container mx-auto bg-white rounded-xl shadow-md md:p-6 p-3">
        <DateSelect
          fetchVenueSlotsList={fetchVenueSlotsList}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />

        <div className="mt-4 ">
          <div className="border-t "></div>
          <div className="py-1 flex items-center font-semibold text-md">
            <FaCircle color="#0ea5e9" />
            &nbsp; Available &nbsp; &nbsp; &nbsp; &nbsp;
            <FaCircle color="#9ca3af" /> &nbsp; Blocked
          </div>
          <div className="border-t "></div>
        </div>

        {/* Block Arena */}

        {venueBookingSlotsList?.data?.length > 0 &&
          !venueBookingSlotsList?.data[0]?.courdBooked && (
            <label className="flex items-center gap-2 my-3 cursor-pointer ">
              {isBlock ? (
                <FaCircle color="#0ea5e9" className="h-5 w-5" />
              ) : (
                <FaRegCircle
                  className=" cursor-pointer h-5 w-5"
                  onClick={() => {
                    setIsBlock(true);
                    setShowDeleteArenaDialog(true);
                  }}
                />
              )}
              <span className="font-semibold text-lg select-text ">
                Block this arena
              </span>
            </label>
          )}
        {/*  slots */}
        <div className="space-y-4 mb-2">
          {slotsData?.map((slot) => {
            return (
              <div key={slot?.id} className="border rounded-md shadow-sm">
                <div className="flex justify-between items-center p-4 bg-gray-100 hover:bg-gray-100">
                  <div className="flex w-full justify-between">
                    <p className="text-sky-500 font-semibold text-lg">
                      {slot?.courtName}
                    </p>
                    <p className="text-sm text-gray-500">
                      Available spaces:{" "}
                      <span className=" text-lg font-semibold text-highlight">
                        {" "}
                        {slot?.availableSpace}
                      </span>
                    </p>
                  </div>
                </div>
                {!slot?.courdBooked && (
                  <div className="p-4">
                    {slot?.slots?.length > 0 ? (
                      <>
                        <div className="grid  grid-cols-8 gap-4 mb-6">
                          {slot?.slots.map((time) => {
                            return (
                              <button
                                key={time?.slotId}
                                onClick={() =>
                                  toggleSlot(time?.slotId, time?.sportId)
                                }
                                disabled={!time?.slotAvailable}
                                className={`py-3 rounded-lg text-sm font-medium
                    ${
                      !time?.slotAvailable
                        ? "bg-gray-300 text-black cursor-not-allowed"
                        : time?.isSelected
                        ? "bg-green-500 text-white"
                        : "bg-sky-500 hover:bg-sky-600 text-white"
                    }`}
                              >
                                {`${time?.fromTime}-${time?.toTime}`}
                              </button>
                            );
                          })}
                        </div>

                        <div className="flex justify-center">
                          <Button
                            onClick={() => handleMarkAsBlocked()}
                            disabled={
                              !slotsData?.some((item) =>
                                item?.slots?.some((slot) => slot?.isSelected)
                              )
                            }
                            className="disabled:opacity-50"
                          >
                            Mark as blocked
                          </Button>
                        </div>
                      </>
                    ) : (
                      <div className="text-lg text-center">
                        No slots are available to block
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {/* Blocked slots */}
        {venueBookingSlotsList?.data?.length > 0 &&
          !venueBookingSlotsList?.data[0]?.courdBooked && (
            <Accordion allowZeroExpanded>
              <AccordionItem className="rounded-xl">
                <AccordionItemHeading>
                  <AccordionItemButton className=" flex items-center justify-between p-3 bg-[#f9f9f9]">
                    <div className="text-center w-full select-none font-medium md:text-md text-base">
                      View Blocked Slots
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>

                <AccordionItemPanel className="p-3">
                  {venueBookedSlotsData?.length > 0 ? (
                    venueBookedSlotsData?.map((slot) => {
                      return (
                        <div
                          key={slot?.courtName}
                          className="border rounded-md shadow-sm"
                        >
                          <div className="p-4">
                            {slot?.slots?.map((subSlot, index) =>
                              subSlot?.slots?.length > 0 ? (
                                <div key={index}>
                                  <div className="grid  grid-cols-8 gap-4 mb-6">
                                    {subSlot?.slots?.map((time) => {
                                      return (
                                        <button
                                          key={time?.bookingId}
                                          onClick={() =>
                                            toggleUnblockSlot(time?.bookingId)
                                          }
                                          className={`py-3 rounded-lg text-sm font-medium
                    ${
                      time?.isUnblockSelected
                        ? "bg-green-500 text-white"
                        : "bg-gray-200 text-black"
                    }`}
                                        >
                                          {`${time?.fromTime}-${time?.toTime}`}
                                        </button>
                                      );
                                    })}
                                  </div>
                                  <div className="flex justify-center">
                                    <Button
                                      onClick={handleMarkAsUnBlocked}
                                      disabled={
                                        !venueBookedSlotsData?.some((court) =>
                                          court?.slots?.some((slotGroup) =>
                                            slotGroup?.slots?.some(
                                              (slot) => slot?.isUnblockSelected
                                            )
                                          )
                                        )
                                      }
                                      className="disabled:opacity-50"
                                    >
                                      Mark as Unblocked
                                    </Button>
                                  </div>
                                </div>
                              ) : (
                                <div className="md:text-lg text-md text-center">
                                  No slots are available to unblock
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="flex justify-center items-center text-md ">
                      No slots have been blocked yet.
                    </div>
                  )}
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          )}
      </div>
      {/* block arena dialog */}
      <ConfirmationDialog
        isDialogOpen={{
          open: showDeleteArenaDialog,
          message: "Are you sure you want to block this arena?",
        }}
        onConfirm={() => {
          setShowDeleteArenaDialog(false);
          handleMarkAsBlocked(true);
        }}
        cancelButtonName="No"
        actionButtonName="Yes"
        buttonShow={["Cancel", "actionButton"]}
        closeDialog={() => {
          setIsBlock(false);
          setShowDeleteArenaDialog(false);
        }}
      />
    </div>
  );
};

export default ArenaDetails;
